export default "__VITE_ASSET__sE$BJiYX__"